import Loading from '../../components/Loading'
import * as React from 'react'
import { ReactElement } from 'react'
import FilePartyList, { FilePartyListProps } from '../../components/List/FileParty/FilePartyList'
import PartyConnectButton from '../../components/Form/PartyConnectButton'
import { makeStyles, MessageBar, tokens } from '@fluentui/react-components'
import { FilePartyRoleDto } from '../../context/GlobalContext'
import { useSettings } from '../../hooks/useSettings'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
    alert: {
        marginLeft: tokens.spacingHorizontalS,
        marginRight: tokens.spacingHorizontalS,
    },
})

export type FilePartyOverviewProps = Omit<FilePartyListProps, 'roles'>

export default function FilePartyOverview(props: FilePartyOverviewProps): ReactElement {
    const settings = useSettings()
    const styles = useStyles()
    const { t: translate } = useTranslation()

    const roles: FilePartyRoleDto[] = settings?.filePartyRoles

    if (!roles || !props.data) {
        return <Loading />
    }

    return (
        <>
            {props.data.length === 0 ? (
                <MessageBar intent="info" className={styles.alert}>
                    {translate('file.pivot.party.list.empty')}
                </MessageBar>
            ) : (
                <FilePartyList {...props} />
            )}

            <PartyConnectButton
                iconProps={{ iconName: 'Add' }}
                fileId={props.file.id}
                exclude={props.data.flatMap(party => [party, ...party.children])}
                roles={roles}
                translateFunction={translate}
            />
        </>
    )
}
